<template lang="pug">
  v-dialog(:value="visible" @click:outside="close" @keydown.esc="close" max-width="400")
    v-card
      v-toolbar(color="success")
        v-btn(icon dark @click="close")
          v-icon mdi-close
        v-toolbar-title Take ownership
      v-card-text
        v-container
          v-checkbox(
            v-model="copyLibraries"
            @change="$emit('blur', copyLibraries)"
            color="success"
            label="Copy libraries to my page"
            ).default
      v-card-actions
        v-spacer
        v-btn(color="success" @click="$emit('submit')" class="mx-2" text) YES, TAKE OWNERSHIP
</template>

<script>

export default {
  name: 'Own',
  model: {
    prop: 'copyLibraries',
    event: 'blur',
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    copyLibraries: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>

</style>
